import script from "./ContractDetailPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./ContractDetailPanel.vue?vue&type=script&setup=true&lang=js"

import "./ContractDetailPanel.vue?vue&type=style&index=0&id=3dfb2080&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3dfb2080"]])

export default __exports__